import set from 'lodash/set';
import { logout } from 'store/modules/user/actions';

let initialized = false;

const addAuthorizationToHeaders = async (config, store) => {
  const { user } = store.getState();
  if (user.token) {
    set(config, 'headers.Authorization', `Bearer ${user.token}`);
    return config;
  }
  return config;
};

const authorizationProvider = (store, client) => {
  if (!initialized) {
    client.interceptors.request.use((config) =>
      addAuthorizationToHeaders(config, store),
    );

    // Add a response interceptor
    client.interceptors.response.use(
      (response) => {
        const { data } = response;
        return data;
      },
      (error) => {
        if (error.response) {
          const { data } = error.response;
          if (data && data.error) {
            if (data.error.msg?.includes('session has expired')) {
              store.dispatch(logout());
            }
            return Promise.reject({
              message: data.error.msg ?? data.error,
              status: data.error.code,
            });
          }
          return Promise.reject({
            data: error.response.data,
            status: error.response.status,
          });
        }
        return Promise.reject(error);
      },
    );
    initialized = true;
  }
};

export default authorizationProvider;
